import React from 'react';

import { token } from '@atlaskit/tokens';
import { Box, xcss } from '@atlaskit/primitives';
import { IconButton } from '@atlaskit/button/new';
import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import RetryIcon from '@atlaskit/icon/core/retry';
import DeleteIcon from '@atlaskit/icon/core/delete';

const aiUnsplashHeaderToolbar = xcss({
	// @ts-expect-error
	backgroundColor: token('elevation.surface'),
	right: '20px',
	bottom: '20px',
	borderRadius: token('space.075'),
	// @ts-expect-error
	padding: '4px 8px',
	position: 'absolute',
	display: 'flex',
	justifyContent: 'center',
	zIndex: '1',
});

const separatorStyles = xcss({
	background: token('color.border'),
	width: '1px',
	height: '20px',
	display: 'inline-block',
	// @ts-expect-error
	margin: `0 ${token('space.100')}`,
	userSelect: 'none',
});

const seperator = <Box xcss={separatorStyles} />;

type AIUnsplashHeaderToolbarProps = {
	onAccept: () => void;
	onRegenerate: () => void;
	onRemoveImage: () => void;
	isRegeneratingImage: boolean;
};

export const AIUnsplashHeaderToolbar = ({
	onAccept,
	onRegenerate,
	onRemoveImage,
	isRegeneratingImage,
}: AIUnsplashHeaderToolbarProps) => {
	return (
		<Box xcss={aiUnsplashHeaderToolbar} testId="AIUnsplashHeaderToolbar">
			<IconButton
				onClick={onAccept}
				icon={CheckCircleIcon}
				appearance="subtle"
				spacing="compact"
				testId="AIUnsplashHeaderToolbar-accept"
				label=""
			/>
			{seperator}
			<IconButton
				onClick={!isRegeneratingImage ? onRegenerate : undefined}
				isLoading={isRegeneratingImage}
				icon={RetryIcon}
				appearance="subtle"
				spacing="compact"
				testId="AIUnsplashHeaderToolbar-regenerate"
				label=""
			/>
			{seperator}
			<IconButton
				onClick={onRemoveImage}
				icon={DeleteIcon}
				appearance="subtle"
				spacing="compact"
				testId="AIUnsplashHeaderToolbar-remove"
				label=""
			/>
		</Box>
	);
};
